import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable()
export class CheckForUpdateService {
  updates: SwUpdate;

  constructor(appRef: ApplicationRef, updates: SwUpdate) {
    const appIsStable = appRef.isStable.pipe(first(isStable => isStable === true));
    const everyTenMinutes = interval(10 * 60 * 1000);
    const everyTenMinutesOnceAppIsStable = concat(appIsStable, everyTenMinutes);

    // debug only
    // console.log('test1');
    // const everySixSeconds = interval(6 * 1000);
    everyTenMinutesOnceAppIsStable.subscribe(() => updates.checkForUpdate());
  }
}
